webpackJsonp([14],{

/***/ 175:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _jquery = __webpack_require__(9);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function scrollTo(id) {
  (0, _jquery2.default)([document.documentElement, document.body]).animate({
    scrollTop: (0, _jquery2.default)(id).offset().top - 50
  }, 500);
} /**
   * Unauthenticated renewal form JS
   */

function renderFormError(message) {
  var alert = '<div class="alert alert-danger alert-dismissible" role="alert">\n  <button type="button" class="close" data-dismiss="alert" aria-label="Close"></button>\n  ' + message + '\n  </div>';
  return alert;
}

(0, _jquery2.default)('#wl_renew_registration').submit(function (event) {
  event.preventDefault();

  var formData = {
    firstname: (0, _jquery2.default)('#firstname').val(),
    lastname: (0, _jquery2.default)('#lastname').val(),
    email: (0, _jquery2.default)('#email').val(),
    confirmEmail: (0, _jquery2.default)('#confirmEmail').val(),
    cardtype: (0, _jquery2.default)('#cardtype').val(),
    accountNumber: (0, _jquery2.default)('#accountNumber').val(),
    expirationMonth: (0, _jquery2.default)('#expirationMonth').val(),
    expirationYear: (0, _jquery2.default)('#expirationYear').val(),
    CVV: (0, _jquery2.default)('#CVV').val(),
    wl_renew_registration_nonce: (0, _jquery2.default)('#wl_renew_registration_nonce').val(),
    recaptcha: grecaptcha.getResponse()
  };

  _jquery2.default.ajax({
    type: 'POST',
    url: '/wp-admin/admin-ajax.php?action=wl_renew_registration',
    data: formData,
    dataType: 'json'
  }).done(function (data) {
    window.location.replace('/renew-your-membership/confirmation/');
  }).fail(function (xhr, status, error) {
    var errorResponse = xhr.responseJSON.data;

    if (errorResponse.first_name) {
      (0, _jquery2.default)('#firstname-field').addClass('has-error');
      (0, _jquery2.default)('#firstname-error').text(errorResponse.first_name);
      (0, _jquery2.default)([document.documentElement, document.body]).animate({
        scrollTop: (0, _jquery2.default)('#firstname-field').offset().top
      }, 500);
    }

    if (errorResponse.last_name) {
      (0, _jquery2.default)('#lastname-field').addClass('has-error');
      (0, _jquery2.default)('#lastname-error').text(errorResponse.last_name);
      (0, _jquery2.default)([document.documentElement, document.body]).animate({
        scrollTop: (0, _jquery2.default)('#lastname-field').offset().top
      }, 500);
    }

    if (errorResponse.email) {
      (0, _jquery2.default)('#email-field').addClass('has-error');
      (0, _jquery2.default)('#email-error').text(errorResponse.email);
      (0, _jquery2.default)([document.documentElement, document.body]).animate({
        scrollTop: (0, _jquery2.default)('#email-field').offset().top
      }, 500);
    }

    if (errorResponse.confirmEmail) {
      (0, _jquery2.default)('#confirm-email-field').addClass('has-error');
      (0, _jquery2.default)('#confirmEmail-error').text(errorResponse.confirmEmail);
      (0, _jquery2.default)([document.documentElement, document.body]).animate({
        scrollTop: (0, _jquery2.default)('#confirm-email-field').offset().top
      }, 500);
    }

    if (errorResponse.email_mismatch) {
      (0, _jquery2.default)('#email-field, #confirm-email-field').addClass('has-error');
      (0, _jquery2.default)('#email-error').text(errorResponse.email_mismatch);
      (0, _jquery2.default)([document.documentElement, document.body]).animate({
        scrollTop: (0, _jquery2.default)('#email-field').offset().top
      }, 500);
    }

    if (errorResponse.gateway) {
      (0, _jquery2.default)('#form-errors').html(renderFormError(errorResponse.gateway));
      scrollTo('#form-errors');
    }

    if (errorResponse.user) {
      (0, _jquery2.default)('#form-errors').html(renderFormError('This email address is not associated to a BAFFC membership. Please use a registered email address instead or <a href="/membership/registration/">click here to become a member</a>.'));
      scrollTo('#form-errors');
    }

    if (errorResponse.credit_card_number) {
      (0, _jquery2.default)('#accountNumber-field').addClass('has-error');
      (0, _jquery2.default)('#accountNumber-error').text(errorResponse.credit_card_number);
    }

    if (errorResponse.expiration_date) {
      (0, _jquery2.default)('#expirationDate-field').addClass('has-error');
      (0, _jquery2.default)('#expirationDate-error').text(errorResponse.expiration_date);
    }

    if (errorResponse.cvv) {
      (0, _jquery2.default)('#CVV-field').addClass('has-error');
      (0, _jquery2.default)('#CVV-error').text(errorResponse.cvv);
    }

    if (errorResponse.recaptcha) {
      (0, _jquery2.default)('#form-errors').html(renderFormError('Please Check ReCaptcha'));
      scrollTo('#form-errors');
    }

    (0, _jquery2.default)('#submit').prop('disabled', false);
  });
});

var fields = ['#firstname', '#lastname', '#email', '#confirmEmail', '#accountNumber', '#CVV'];

fields.forEach(function (field) {
  (0, _jquery2.default)(field).blur(function () {
    (0, _jquery2.default)(field + '-field').removeClass('has-error');
    (0, _jquery2.default)(field + '-error').text('');
  });
});

(0, _jquery2.default)('#expirationMonth, #expirationYear').blur(function () {
  (0, _jquery2.default)('#expirationDate-field').removeClass('has-error');
  (0, _jquery2.default)('#expirationDate-error').text('');
});

/***/ })

},[175]);


// WEBPACK FOOTER //
// registration-renewal.d632847c.js